"use strict";
Object.defineProperty(exports, Symbol.toStringTag, { value: "Module" });
const isRepositoryName = (input) => {
  return /^[a-zA-Z0-9][-a-zA-Z0-9]{2,}[a-zA-Z0-9]$/.test(input);
};
exports.isRepositoryName = isRepositoryName;
//# sourceMappingURL=isRepositoryName.cjs.map
